import { Link } from "react-router-dom";
import { useLegalTranslation } from "@/hooks";
import { LEGAL_FOOTER_LINKS } from "@/lib/constants/legal";

/**
 * Global site footer (2026 rebrand): forest surface with the lime lockup per
 * the monochrome contrast-pair rule (DESIGN.md §7.2). Brand lockup left,
 * legal nav center, copyright right; stacks vertically on mobile. Aligned
 * with the landing chrome cap (90rem).
 */
export function LegalFooter() {
  const { t } = useLegalTranslation();

  return (
    <footer className="bg-green-600 text-primary-foreground" role="contentinfo">
      <div className="mx-auto w-full max-w-[min(90rem,calc(100vw-1.5rem))] px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between">
          <Link
            to="/"
            className="inline-flex items-center rounded-md px-1 py-0.5 outline-none transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-accent-lime focus-visible:ring-offset-2 focus-visible:ring-offset-green-600"
            aria-label="ThinkEat home"
          >
            <img
              src="/brand/lockup-lime.svg"
              alt="ThinkEat"
              className="h-6 w-auto select-none sm:h-7"
              draggable={false}
            />
          </Link>

          <nav
            className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-sm font-medium text-accent-lime/90"
            aria-label={t("footer.copyright", { year: new Date().getFullYear() })}
          >
            {LEGAL_FOOTER_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="whitespace-nowrap transition-colors hover:text-accent-lime"
              >
                {t(link.labelKey)}
              </Link>
            ))}
          </nav>

          <p className="text-center font-mono text-xs text-primary-foreground/80 md:text-right">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}
